import { Body, Button } from '@e2n/ui/v2';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { useTranslation } from 'react-i18next';

export function KalenderWeekPicker() {
  const { t } = useTranslation();
  const {
    store: {
      setCurrentEndOfWeek,
      setCurrentStartOfWeek,
      ui: {
        kalender: { currentEndOfWeek, currentStartOfWeek },
      },
    },
  } = useRotationsplanFeatureContext();

  function handlePrevKWClick() {
    const newStartOfWeek = dayjs(currentStartOfWeek)
      .subtract(1, 'week')
      .startOf('isoWeek')
      .toISOString();

    const newEndOfWeek = dayjs(currentStartOfWeek)
      .subtract(1, 'week')
      .endOf('isoWeek')
      .toISOString();

    setCurrentStartOfWeek(newStartOfWeek);
    setCurrentEndOfWeek(newEndOfWeek);
  }

  function handleNextKWClick() {
    const newStartOfWeek = dayjs(currentStartOfWeek)
      .add(1, 'week')
      .startOf('isoWeek')
      .toISOString();

    const newEndOfWeek = dayjs(currentStartOfWeek)
      .add(1, 'week')
      .endOf('isoWeek')
      .toISOString();

    setCurrentStartOfWeek(newStartOfWeek);
    setCurrentEndOfWeek(newEndOfWeek);
  }

  return (
    <div className="flex w-full items-center justify-between border-b border-neutrals-v2-300 bg-backgrounds-primary px-4 py-2">
      <Button
        variant="ghost"
        iconOnly
        aria-label={t('actions.back')}
        onClick={handlePrevKWClick}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </Button>
      <Body className="px-4 py-2" weight="semibold">
        KW {dayjs(currentStartOfWeek).isoWeek()} (
        {`${dayjs(currentStartOfWeek).format('DD.MM.')} – ${dayjs(currentEndOfWeek).format('DD.MM.YYYY')}`}
        )
      </Body>
      <Button
        variant="ghost"
        iconOnly
        aria-label={t('actions.next')}
        onClick={handleNextKWClick}>
        <FontAwesomeIcon icon={faChevronRight} />
      </Button>
    </div>
  );
}
